<div class="notification" *ngIf="notification" @show>
    <div class="flex">
        <div class="notification__body flex-grow">
            {{ notification.body}}
        </div>

        <button class="notification__button notification__button--close" type="button" (click)="handleCloseClick()">
            <app-icon icon="times"></app-icon>
        </button>
    </div>
    
    <button
        class="notification__button notification__button--full"
        type="button"
        *ngIf="notification.action"
        (click)="handleActionClick()">
        {{ notification.action }}
    </button>
</div>
